import { render, staticRenderFns } from "./ProductCombinationPricesForm.vue?vue&type=template&id=46f54cc0&scoped=true&"
import script from "./ProductCombinationPricesForm.vue?vue&type=script&lang=js&"
export * from "./ProductCombinationPricesForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductCombinationPricesForm.vue?vue&type=style&index=0&id=46f54cc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f54cc0",
  null
  
)

export default component.exports